<!--
   Created by qing on 2021/6/3
   Des:
-->
<template>

  <div>
    <van-cell class="ry-form__single-line" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead"
          v-html="currentRow[dataId].value">
        </div>

        <van-field
          v-if="!isRead"
          v-model="currentRow[dataId].value"
          is-link
          readonly
          :placeholder="isReadOnly ? '暂无内容' : '请选择内容'"
          @click="openSelect"
        />

      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__single-line-compact">

      <van-field
        v-if="isRead"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div v-html="currentRow[dataId].value">
          </div>
        </template>
      </van-field>

      <van-field
        v-if="!isRead"
        is-link
        readonly
        v-model="currentRow[dataId].value"
        :placeholder="isReadOnly ? '暂无内容' : '请选择内容'"
        :label="current.title"
        :required="Boolean(!isRead && current.required)"
        @click="openSelect">
      </van-field>
    </div>

    <van-popup
      class="cascade-field-popup"
      v-if="!isRead"
      v-model="show"
      round
      get-container="body"
      position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择"
        active-color="#1989fa"
        :options="dataList"
        @close="show = false"
        @change="onChange"
        @finish="onFinish"
      />
      <div class="footer" v-if="!current.chooseEnd">

        <van-button
          type="default"
          round
          @click="show = false">
          取消
        </van-button>
        <van-button
          type="primary"
          round
          @click="confirm">
          确定
        </van-button>
      </div>
    </van-popup>
    <RySelectPopup
      v-if="current.pluginConfig && current.pluginConfig.entryId"
      ref="rySelectPopup"
      :title="current.title"
      @selectComplete="selectComplete">
    </RySelectPopup>
  </div>
</template>

<script>
  import { current } from './mixin'

  let id = 0;
  export default {
    mixins: [current],
    data() {
      return {
        show: false,
        dataList: [],
        allDataList: [],
        cascaderValue: '',
        selectValues: []
      }
    },
    created() {
      if (this.currentRow[this.dataId] && this.currentRow[this.dataId].originValueList && this.currentRow[this.dataId].originValueList.length) {
        this.cascaderValue = this.currentRow[this.dataId].originValueList[this.currentRow[this.dataId].originValueList.length - 1].instanceId

      }
    },
    computed: {

    },
    methods: {
      openSelect() {
        if (this.isReadOnly) {
          this.$toast.fail('当前控件不可编辑')
          return
        }
        this.show = true
        this.fetchData({
          level: 0
        }).then(res => {
          const nodes = []
          res.forEach(item => {
            if (!this.dataList.filter(d => d.value === item.instanceId)[0]){
              nodes.push({
                text: item.value,
                appId: item.appId,
                formId: item.formId,
                value: item.instanceId,
                level: 0,
                hasNext: item.hasNext,
                children: item.hasNext ? [] : null,
              })
            }
          })
          console.log('nodes', nodes)
          this.dataList.push(...nodes)
          this.allDataList.push(...nodes)
        }).catch(console.error)
      },
      onChange({selectedOptions, value}) {
        if (!selectedOptions || !selectedOptions.length) {
          return
        }
        const opt = selectedOptions.filter(item => item.value === value)[0]
        console.log('onChange', opt, value)
        this.selectValues = selectedOptions.map(item => item.value)
        if (!opt || !opt.hasNext) {
          return;
        }
        this.fetchData({
          level: opt.level + 1,
          instanceId: opt.value
        }).then(res => {
          res.forEach(item => {
            const optItem = {
              text: item.value,
              appId: item.appId,
              formId: item.formId,
              value: item.instanceId,
              level: opt.level + 1,
              hasNext: item.hasNext,
              children: item.hasNext ? [] : null,
            }
            if (!opt.children.filter(c => c.value === optItem.value)[0]) {
              opt.children.push(optItem)
              this.allDataList.push(optItem)
            }
          })
        }).catch(console.error)
      },
      fetchData({level, instanceId}) {
        if (this.current.relateType === 'SELF') {
          return this.$store.dispatch('actionFormCascadeLocalData', {
            appId: this.current.root.appId,
            formId: this.current.root.formId,
            relateFieldId: this.current.dataId,
            instanceIdList: instanceId ? [instanceId] : [],
            firstLevel: !level ? 1 : 0
          })
        } else {
          return this.$store.dispatch('actionFormCascadeRemoteData', {
            appId: this.current.root.appId,
            formId: this.current.root.formId,
            relateFieldId: this.current.dataId,
            instanceIdList: instanceId ? [instanceId] : [],
            requestLevel: level + 1
          })
        }
      },
      onFinish(opt) {
        if (!this.current.chooseEnd) {
          return
        }
        this.show = false;

        const selectedOptions = opt.selectedOptions
        console.log('selectedOptions', opt, this.allDataList)
        this.currentRow[this.dataId].originValueList.splice(0, this.currentRow[this.dataId].originValueList.length)
        this.currentRow[this.dataId].value = ''
        selectedOptions.forEach((item, idx) => {
          const selectItem = this.allDataList.filter(data => data.value === item.value)[0]
          if (selectItem) {
            this.currentRow[this.dataId].originValueList.push({
              index: idx,
              appId: selectItem.appId,
              formId: selectItem.formId,
              instanceId: selectItem.value,
              value: selectItem.text
            })
            if (this.current.showPath) {
              this.currentRow[this.dataId].value += `${selectItem.text}/`
            } else {
              if (idx === selectedOptions.length - 1) {
                this.currentRow[this.dataId].value = selectItem.text
              }
            }
          }
        })
        if (this.current.showPath) {
          this.currentRow[this.dataId].value = this.currentRow[this.dataId].value.substr(0, this.currentRow[this.dataId].value.length - 1)
        }

        console.log('onFinish', this.currentRow[this.dataId], this.cascaderValue)
      },

      confirm() {

        this.currentRow[this.dataId].originValueList.splice(0, this.currentRow[this.dataId].originValueList.length)
        this.currentRow[this.dataId].value = ''
        console.log('this.selectValues', this.selectValues)
        this.selectValues.forEach((v, idx) => {
          const selectItem = this.allDataList.filter(data => data.value === v)[0]
          if (selectItem) {
            this.currentRow[this.dataId].originValueList.push({
              index: idx,
              appId: selectItem.appId,
              formId: selectItem.formId,
              instanceId: selectItem.value,
              value: selectItem.text
            })
            if (this.current.showPath) {
              this.currentRow[this.dataId].value += `${selectItem.text}/`
            } else {
              if (idx === this.selectValues.length - 1) {
                this.currentRow[this.dataId].value = selectItem.text
              }
            }
          }
        })
        if (this.current.showPath) {
          this.currentRow[this.dataId].value = this.currentRow[this.dataId].value.substr(0, this.currentRow[this.dataId].value.length - 1)
        }

        this.show = false;
        this.controlChange()
      }
    }
  }
</script>

<style lang="less">

  .cascade-field-popup {

    .footer {
      border-top: 1px solid #ebedf0;
      height: 60px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .van-button--default {
        background-color: #ffffff;
        border: 1px solid #4A66FA;
        color: #4A66FA;
      }
      .van-button {
        width: 40%;
      }

    }
  }
</style>
